module.exports = __webpack_public_path__ + "static/media/logo-new.89243a01.png";